import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
    displayName = Layout.name

    render() {
        return (
            <Grid fluid>
                <Row>
                    <Col sm={3} style={{ width: '18%', maxWidth: '280px' }}>
                        <NavMenu />
                    </Col>
                    <Col sm={9} style={{ width: '82%', maxWidth: 'none', flex: 1 }}>
                        {this.props.children}
                    </Col>
                </Row>
            </Grid>
        );
    }
}
